
import { Vue } from "vue-class-component";

export default class StoSC extends Vue {}
